import emitter from 'tiny-emitter/instance';

export default {
    $on: (key, func) => emitter.on(key, func),
    $once: (key, func) => emitter.once(key, func),
    $off: (key, func) => emitter.off(key, func),
    $emit: (key, ...args) => emitter.emit(key, ...args),
};
